import { AfterViewInit, Component, ElementRef, Input, NgZone } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { Article, Rumour } from '../../../../../../core/models/rumour.model';
import { NewsService } from '../../../../services/news.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'articles-card',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule
  ],
  templateUrl: 'articles-card.component.html',
  styleUrl: 'articles-card.component.css'
})
export class ArticlesCard implements AfterViewInit{
  @Input() article: Article | null = null
  isCompact = false

  constructor(
    public service: NewsService,
    protected auth: AuthService,
    private elementRef: ElementRef,
    private zone: NgZone
  ) {}
  
  ngAfterViewInit() {
    const card = this.elementRef.nativeElement.querySelector('.article-card')
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.zone.run(() => {
          this.isCompact = (entry.target as HTMLElement).offsetWidth < 570
        })
      }
    })
    observer.observe(card)
  }
}